import React, { Component } from 'react';
import ContactList from '../../../components/contact-list-component';

export default class StepContactList extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return this.props.isHidden ? null : (
            <div style={{ marginBottom: '20px' }} className="workflow form">
                <h6>File Contacts</h6>
                <hr className="section-header" />
                <ContactList {...this.props} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/workflow/steps/components/step-contact-list.js